import { useCallback, useRef } from "react";

function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max);
}

export function useDragResize(onResize, onResizeEnd) {
  const dragRef = useRef(null);

  const onResizeStart = useCallback(
    (axis, event) => {
      event.preventDefault();
      event.stopPropagation();

      dragRef.current = {
        axis,
        startX: event.clientX,
        startY: event.clientY,
      };

      const onMove = (moveEvent) => {
        const drag = dragRef.current;
        if (!drag) return;

        const dx = moveEvent.clientX - drag.startX;
        const dy = moveEvent.clientY - drag.startY;
        drag.startX = moveEvent.clientX;
        drag.startY = moveEvent.clientY;

        onResize(drag.axis, dx, dy);
      };

      const onUp = () => {
        dragRef.current = null;
        window.removeEventListener("mousemove", onMove);
        window.removeEventListener("mouseup", onUp);
        if (onResizeEnd) {
          onResizeEnd();
        }
      };

      window.addEventListener("mousemove", onMove);
      window.addEventListener("mouseup", onUp);
    },
    [onResize, onResizeEnd]
  );

  return { onResizeStart };
}

export function clampSize(value, min, max) {
  return clamp(value, min, max);
}
